import { getTestIds } from 'seagull/utils/TestIds';
export const AttachFilesTestIds = getTestIds('AttachFilesTestIds');